package com.yendo.mx.utils

import androidx.compose.runtime.Composable

@Composable
actual fun rememberYendoImagePickerLauncher(
    onResult: (List<ByteArray>) -> Unit
): YendoImagePickerLauncher {
    return object : YendoImagePickerLauncher {
        override fun launch() {
            onResult(emptyList())
        }
    }
}
